@let control = getControl();

<div class="file-upload-control-wrapper">
  <htx-file-upload-field
    [ctrl]="ctrl()"
    [uploadIcon]="uploadIcon()"
    [uploadText]="uploadText()"
    [dragDropText]="dragDropText()"
    [changeText]="changeText()"
    [acceptedFileTypes]="acceptedFileTypes()">
  </htx-file-upload-field>

  @if (ctrl().invalid && (ctrl().touched || ctrl().dirty)) {
    <htx-error-field
      [control]="control"
      [errorMessages]="{
        required: errorMessages()['required'],
        fileTooLarge: getFileSizeErrorMessage(),
        invalidFileType: errorMessages()['invalidFileType'],
        invalidFile: errorMessages()['invalidFile']
      }">
    </htx-error-field>
  }
</div>
